import { IApiError, TApiErrorCallback } from "../api.interfaces";
import { ICredentialsWithServer } from "../credentialsStore";
import { IAuthFailureHandlerApi, IPerTypeStrategy, TNeedsLoginAndCall } from "./interfaces";
import { handleIamEarlyReturn } from "./iamEarlyReturn";

export abstract class ReAuthStrategy implements IPerTypeStrategy {
    constructor(protected readonly api: IAuthFailureHandlerApi) {}

    handle(error: IApiError, errorCallback: TApiErrorCallback | undefined, needsLoginAndCall: TNeedsLoginAndCall): void {
        const credentials = this.api.credentialsStore.get();

        if (handleIamEarlyReturn(this.api, credentials)) {
            errorCallback?.(error);
            return;
        }

        this.cleanCredentials();
        this.invokeReLogin(error, credentials, needsLoginAndCall);
        errorCallback?.(error);
    }

    protected invokeReLogin(_error: IApiError, _credentials: ICredentialsWithServer | null, needsLoginAndCall: TNeedsLoginAndCall): void {
        needsLoginAndCall();
    }

    protected cleanCredentials() {
        this.api.clearInMemoryCredentials();
        this.api.credentialsStore.clear();
    }
}

export class DefaultReAuthStrategy extends ReAuthStrategy {}
